/** SAVE_FOR_TEMP */
export const SAVE_FOR_TEMP = (payload: any) => ({
    type: "SAVE_FOR_TEMP",
    payload,
})
